import { AuthBaseClient } from '../base-client';
import type { MedicalCodeResult, MedicalCodeType } from './types';

/**
 * Client for medical code search API.
 * Used for ICD-10-CM, CPT, and HCPCS code autocomplete.
 */
export class MedicalCodeClient extends AuthBaseClient {
  /**
   * Search medical codes by prefix or description.
   */
  async search(
    type: MedicalCodeType,
    query: string,
    limit: number = 20
  ): Promise<MedicalCodeResult[]> {
    const params = new URLSearchParams({ q: query, type, limit: String(limit) });
    return this.get<MedicalCodeResult[]>(`/api/medical-codes?${params.toString()}`);
  }
}
